// Header.js
import React, { useState } from "react";
import IconMenu from "./iconMenu";
import "../media/css/header.css";

const Header = ({ activeIndex, onSectionChange }) => {
  const sectionsId = ["home", "about", "resume", "portfolio", "contact"];
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleClick = (index) => {
    onSectionChange(index);
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
    setIsFullscreen(!isFullscreen);
  };

  return (
    <header className="page-header">
      <div className="container">
        <input type="checkbox" id="menu-check" />
        <label htmlFor="menu-check" className="menu-btn">
          <IconMenu />
        </label>
        <nav>
          {sectionsId.map((section, index) => (
            <button
              key={section}
              className={activeIndex === index ? "active" : ""}
              onClick={() => handleClick(index)}
            >
              {section}
            </button>
          ))}
        </nav>
        <div className="phone">
          <i className="bi bi-phone"></i> +7 123 555 010
        </div>
      </div>
      <button className="screen-btn" onClick={toggleFullscreen}>
        <i
          className={`bi ${
            isFullscreen ? "bi-fullscreen-exit" : "bi-fullscreen"
          }`}
        ></i>
      </button>
    </header>
  );
};

export default Header;
